﻿import { ajaxGet, ajaxPost } from '../../utils/ajax';
export default {

checkContractsSignature(orderId, dealerCode, userId, callback, errorCallback) {    
    var url = "/teliadk/OrderSummaryCreditAccountBlock/CheckContractsSignatureAsync?orderId=" + orderId + "&dealerCode=" + dealerCode + "&userId=" + userId;
    ajaxGet(url, true, true)
        .then(callback)
        .catch(errorCallback);  
},
hasAnyContract(orderId, dealerCode, userId, callback, errorCallback) {
    var url = "/teliadk/OrderSummaryCreditAccountBlock/HasAnyContractAsync?orderId=" + orderId + "&dealerCode=" + dealerCode + "&userId=" + userId;
    ajaxGet(url, true, true)
        .then(callback)
        .catch(errorCallback);
    },
hasAnyTeliaContract(orderId, dealerCode, userId, callback, errorCallback) {
    var url = "/teliadk/OrderSummaryCreditAccountBlock/HasAnyTeliaContractAsync?orderId=" + orderId + "&dealerCode=" + dealerCode + "&userId=" + userId;
    ajaxGet(url, true, true)
        .then(callback)
        .catch(errorCallback);
},
getTeliaContracts(orderId, dealerCode, userId, callback, errorCallback) {       
    var url = "/teliadk/OrderSummaryCreditAccountBlock/GetTeliaContractsAsync?orderId=" + orderId + "&dealerCode=" + dealerCode + "&userId=" + userId;
    ajaxGet(url, true, true)
        .then(callback)
        .catch(errorCallback);  
},
getTFContracts(orderId, dealerCode, userId, callback, errorCallback) { 
    var url = "/teliadk/OrderSummaryCreditAccountBlock/GetTFContractsAsync?orderId=" + orderId + "&dealerCode=" + dealerCode + "&userId=" + userId;
    ajaxGet(url, true, true)
        .then(callback)
        .catch(errorCallback);
},
signContracts(orderId, dealerCode, channelType, userId, signatureString, callback, errorCallback) {  
    var url = "/teliadk/ContractsSignitureCreditAccountBlock/SignContractsAsync?orderId=" + orderId + "&dealerCode=" + dealerCode + "&channelType=" + channelType + "&userId=" + userId;
    const parameters = {
        'signatureString': signatureString        
    };

    ajaxPost(url, parameters, true)
        .then(callback)
        .catch(errorCallback);
},
signContractsByName(orderId, dealerCode, channelType, userId, signatureString, signer, callback, errorCallback) { 
    var url = "/teliadk/ContractsSignitureCreditAccountBlock/SignContractsByNameAsync?orderId=" + orderId + "&dealerCode=" + dealerCode + "&channelType=" + channelType + "&userId=" + userId +"signatureDetails" + JSON.stringify(signer.SignatureDetails);
    const parameters = {        
            'SignatureString': signatureString,  
            'Signer.ErrorMessage': signer.ErrorMessage,
            'Signer.FailedSigning': signer.FailedSigning,
            'Signer.FlagedSignature': signer.FlagedSignature,
            'Signer.FullName': signer.FullName,
            'Signer.MarkedAsSigned': signer.MarkedAsSigned,
            'SignatureDetails': JSON.stringify(signer.SignatureDetails)
    };
    ajaxPost(url, parameters, true)
        .then(callback)
        .catch(errorCallback);
}
}

